import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VCard,{attrs:{"shaped":"","outlined":_vm.isPast}},[_c(VCardTitle,{staticClass:"justify-center"},[_vm._v("\n    "+_vm._s(_vm.displayDateString)+" "),_c(VSpacer),_c(VBtn,{attrs:{"text":""},on:{"click":_vm.emitDeleteClick}},[_c(VIcon,{attrs:{"color":"red","large":""}},[_vm._v(" mdi-delete-outline ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }